import React, { useEffect, useState } from "react";
import Header from "./Header";
import { GoPeople } from "react-icons/go";
import { FaArrowRight } from "react-icons/fa6";
import { LuBuilding2 } from "react-icons/lu";
import { IoBagRemoveOutline } from "react-icons/io5";
import axiosInstance from "../../axios/axios";
import { Link } from "react-router-dom";

const AdminDashboard = () => {
  const [orgs, setOrgs] = useState([]);
  const [analytics, setAnalytics] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchOrgs = async () => {
    try {
      const res = await axiosInstance.get("all_orgs_admin_View");
      const foundJobs = res.data.organizations;
      const statistics = res.data.analytics;
      setOrgs(foundJobs);
      setAnalytics(statistics);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchOrgs();
  }, []);
  let i = 1;
  return (
    <div>
      <Header />
      <div className="container-md">
        <div className="adminHero flex justify-evenly overflow-auto mx-4">
          <div className="bg-white rounded shadow-md p-6 m-4 md:w-2/5">
            <div className="flex items-center gap-4 justify-between">
              <p className="text-sm text-[#787878]">Total Users</p>
              <div>
                <GoPeople
                  className="bg-[#049645] text-white p-1 rounded-md"
                  size={35}
                />
              </div>
            </div>
            <div className="flex items-center gap-4 mt-3 justify-between">
              <p className="font-bold text-xl">{analytics.total_students}</p>
              <FaArrowRight size={30} />
            </div>
          </div>
          <div className="bg-white rounded shadow-md p-6 m-4 md:w-2/5">
            <div className="flex items-center gap-4 justify-between">
              <p className="text-sm text-[#787878]">Total Companies</p>
              <div>
                <LuBuilding2
                  className="bg-[#049645] text-white p-1 rounded-md"
                  size={35}
                />
              </div>
            </div>
            <div className="flex items-center gap-4 mt-3 justify-between">
              <p className="font-bold text-xl">
                {analytics.total_organizations}
              </p>
              <FaArrowRight size={30} />
            </div>
          </div>
          <div className="bg-white rounded shadow-md p-6 m-4 md:w-2/5">
            <div className="flex items-center gap-4 justify-between">
              <p className="text-sm text-[#787878]">Jobs Created</p>
              <div>
                <IoBagRemoveOutline
                  className="bg-[#049645] text-white p-1 rounded-md"
                  size={35}
                />
              </div>
            </div>
            <div className="flex items-center gap-4 mt-3 justify-between">
              <p className="font-bold text-xl">{analytics.total_jobs}</p>
              <FaArrowRight size={30} />
            </div>
          </div>
          <div className="bg-white rounded shadow-md p-6 m-4 md:w-2/5">
            <div className="flex items-center gap-4 justify-between">
              <p className="text-sm text-[#787878]">Applications</p>
              <div>
                <IoBagRemoveOutline
                  className="bg-[#049645] text-white p-1 rounded-md"
                  size={35}
                />
              </div>
            </div>
            <div className="flex items-center gap-4 mt-3 justify-between">
              <p className="font-bold text-xl">
                {analytics.total_applications}
              </p>
              <FaArrowRight size={30} />
            </div>
          </div>
        </div>
      </div>
      <div className="container-md">
        <h1 className="font-bold text-2xl my-4 px-4">Review Organisations</h1>
      </div>
      <div className="container-md my-6 overflow-auto">
        <table className="w-full md:text-lg border-separate border-spacing-4">
          <tr>
            <th>S/N</th>
            <th>Name</th>
            <th>Location</th>
            <th>CAC No.</th>
            <th>Status</th>
            <th></th>
          </tr>
          {loading
            ? "Loading..."
            : orgs.map((each) => (
                <tr key={each.id} className="border-b">
                  <td>{i++}</td>
                  <td>{each.organization.company_name}</td>
                  <td>{each.organization.company_state}</td>
                  <td>{each.organization.company_cac_number}</td>
                  <td>
                    {each.organization.verified === 1 ? "Verified" : "Pending"}
                  </td>
                  <td>
                    <Link to={`/adminorg/details/${each.organization.id}`}>
                      <button
                        className={`w-full bg-gray-300 rounded-md py-1 px-3 ${
                          each.organization.verified === 1
                            ? "bg-green-600"
                            : "bg-red-500"
                        }`}
                      >
                        View Org
                      </button>
                    </Link>
                  </td>
                </tr>
              ))}
        </table>
      </div>
    </div>
  );
};

export default AdminDashboard;
